module.exports = {
      id: "user-usage",
      viewBox: "0 0 496 512",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#user",
      toString: function () {
        return this.url;
      }
    }